import { AssignmentConfiguration } from '@thesisedu/feature-assignments-core'

import { SegmentAssignmentConfiguration } from './types'

export function isSegmentConfiguration(
  configuration: AssignmentConfiguration,
): configuration is SegmentAssignmentConfiguration {
  return !!(configuration as SegmentAssignmentConfiguration).segmentId
}
